import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_r56bdd4kh8: FaireBrandEntity = {
  token: "b_r56bdd4kh8",
  type: "brand",
  name: "Nash Grey",
  avatarUrl:
    "https://cdn.faire.com/fastly/326cefd9d1d101b419b634616ac901c5b2e2fa2c98d46a3ea502b60918b040b5.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/edd6bc050009219533568544bd8d3382d733284dbc1f1b32a088122e69af4660.png",
  logoUrl:
    "https://cdn.faire.com/fastly/326cefd9d1d101b419b634616ac901c5b2e2fa2c98d46a3ea502b60918b040b5.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/edd6bc050009219533568544bd8d3382d733284dbc1f1b32a088122e69af4660.png",
  location: "Nashville , TN, USA",
  minimumOrderDollars: 99,
  rating: 4.9,
  reviewCount: 341,
  isTopShop: true,
  isInsider: true,
  description:
    "Nash Grey was born in 2020 in NASHVILLE TN! We specialize in apparel, accessories, shoes and home goods made in the USA and abroad. New arrivals weekly with low minimums and open sizing. \n\n*Please take note of the products with a pre-order date. These items will ship within 2-5 days of this date.*",
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:55:12.556Z",
    importedBy: "entity-db-cli",
  },
};
